import { Component, OnInit } from '@angular/core';
import { LoadingbarService } from 'src/app/loadingbar.service';
import { useRpcBridge } from './core/rpc-bridge.service';
import { UtilitiesService } from './core/utilities.service';
import { TranslationService } from './core/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLoading$ = this.loading.fetchLoadingBar();
  constructor(
    private loading: LoadingbarService,
    private utils: UtilitiesService,
    private translationSvc: TranslationService
  ) {}

  ngOnInit() {
    this.detectIframe();
    this.initDarkMode();
    this.initRpcBridge();
  }

  async initRpcBridge() {
    const rpc = useRpcBridge(window.parent);
    console.log('[eStore] RPC bridge initialized');
    void rpc.emit('ready');

    try {
      await rpc.call('svo-initial-state').then(async (initialStateData) => {
        console.log('[eStore] Initial state data:', initialStateData);
        if (initialStateData.lang) {
          // useLayoutStore().language = initialStateData.lang;
        }
        if (initialStateData.theme) {
          this.utils.setDarkMode(initialStateData.theme === 'dark');
        }
      });
    } catch (error) {
      console.error('[eStore] Error fetching initial state:', error);
    }

    rpc.on('message', (data: string) => {
      console.log('[eStore] Received message from parent:', data);
      let decodedData = JSON.parse(data);
      if (decodedData.type === 'theme-change') {
        console.log(
          '[eStore] Received change theme from parent (theme-change):',
          decodedData.theme
        );
        this.utils.setDarkMode(decodedData.theme === 'dark');
      } else if (decodedData.type === 'language-change') {
        console.log(
          '[eStore] Received change language from parent (language-change):',
          decodedData.lang
        );
        this.translationSvc.changeLanguage(decodedData.lang);
      }
    });
  }

  initDarkMode() {
    // Initialize dark mode with prefers-color-scheme support
    this.utils.initializeDarkMode();
    // Glass or classic dashboard theme (Preferences > Profile)
    this.utils.initializeUiTheme();
  }

  detectIframe() {
    const isIframe = window.top !== window.self;

    if (isIframe) {
      document.documentElement.classList.add('in-iframe');
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('in-iframe');
      document.documentElement.classList.remove('dark');
    }
  }
}
